import PrivateRoute from "./PrivateRoute";
import React from "react";
import {BrowserRouter as Router, Routes, Route} from "react-router-dom";
import Login from "./components/Login";
import Dashboard from "./components/Dashboard"; // Componente per la dashboard
import Profilo from "./components/Profilo";
import CambioPassword from './components/CambioPassword';
import Annuncio from "./components/Annuncio";
import NuovoAnnuncio from "./components/NuovoAnnuncio";
import NuovoAllegato from "./components/NuovoAllegato";
import SupportoTecnico from "./components/SupportoTecnico";
import NuovaAnagrafica from "./components/NuovaAnagrafica";
import { ForgotPassword, ResetPassword } from "./components/RecuperoPassword";
import AdminDashboard from "./components/AdminDashboard";
import UtentiAdmin from "./components/UtentiAdmin";
import UtenteAdmin from "./components/UtenteAdmin";
import UtenteAdminNew from "./components/UtenteAdminNew.jsx";
import DettaglioUtente from "./components/DettaglioUtente";
import ElencoAnnunci from "./components/ElencoAnnunci";
import DettaglioAnnuncio from "./components/DettaglioAnnuncio";
import NotificheTot from "./components/NotificheTot.jsx";
import NotificaAdminNew from "./components/NotificaAdminNew";
import MessaggioAdmin from "./components/MessaggioAdmin";
import ProfiloAdmin from "./components/ProfiloAdmin";
import CambioPasswordAdmin from "./components/CambioPasswordAdmin.jsx";
import SupportoTecnicoAdmin from "./components/SupportoTecnicoAdmin.jsx";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-buttons/js/dataTables.buttons";
// import "datatables.net-buttons/js/buttons.flash";
import "datatables.net-buttons/js/buttons.html5";
import "datatables.net-buttons/js/buttons.print";
import { UserProvider } from './components/UserContext'; // Importa UserProvider

// PAGINE PUBBLICHE
import AnnunciRecenti from './components/AnnunciRecenti.jsx';
import Cerca from "./components/Cerca.jsx";
import Necrologio from "./components/Necrologio.jsx";
function App() {
  return (
    <Router>
      <UserProvider>
        {/* Avvolgi l'app con il provider */}
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/profilo"
            element={
              <PrivateRoute>
                <Profilo />
              </PrivateRoute>
            }
          />
          <Route
            path="/cambio-password"
            element={
              <PrivateRoute>
                <CambioPassword />
              </PrivateRoute>
            }
          />
          <Route path="/recupera-password" element={<ForgotPassword />} />
          <Route
            path="/reimposta-password/:token"
            element={<ResetPassword />}
          />
          <Route
            path="/nuovo-annuncio"
            element={
              <PrivateRoute>
                <NuovaAnagrafica />
              </PrivateRoute>
            }
          />
          <Route
            path="/supporto"
            element={
              <PrivateRoute>
                <SupportoTecnico />
              </PrivateRoute>
            }
          />
          <Route
            path="/annuncio/:id"
            element={
              <PrivateRoute>
                <Annuncio />
              </PrivateRoute>
            }
          />
          <Route
            path="/nuovo-annuncio/"
            element={
              <PrivateRoute>
                <NuovoAnnuncio />
              </PrivateRoute>
            }
          />
          <Route
            path="/nuovo-allegato"
            element={
              <PrivateRoute>
                <NuovoAllegato />
              </PrivateRoute>
            }
          />
          {/* INIZIO SEZIONE SUPERAMMINISTRATORE */}
          <Route
            path="/amministratore/dashboard"
            element={
              <PrivateRoute>
                <AdminDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/amministratore/utenti"
            element={
              <PrivateRoute>
                <UtentiAdmin />
              </PrivateRoute>
            }
          />
          <Route
            path="/amministratore/utente/:id"
            element={
              <PrivateRoute>
                <UtenteAdmin />
              </PrivateRoute>
            }
          />
          <Route
            path="/amministratore/dettaglio-utente/:id"
            element={
              <PrivateRoute>
                <DettaglioUtente />
              </PrivateRoute>
            }
          />
          <Route
            path="/amministratore/nuovo-utente"
            element={
              <PrivateRoute>
                <UtenteAdminNew />
              </PrivateRoute>
            }
          />
          <Route
            path="/amministratore/supporto"
            element={
              <PrivateRoute>
                <SupportoTecnicoAdmin />
              </PrivateRoute>
            }
          />
          <Route
            path="/amministratore/profilo"
            element={
              <PrivateRoute>
                <ProfiloAdmin />
              </PrivateRoute>
            }
          />
          <Route
            path="/amministratore/cambio-password"
            element={
              <PrivateRoute>
                <CambioPasswordAdmin />
              </PrivateRoute>
            }
          />
          <Route
            path="/amministratore/invia-notifica/:id"
            element={
              <PrivateRoute>
                <NotificaAdminNew />
              </PrivateRoute>
            }
          />
          <Route
            path="/elenco-notifiche"
            element={
              <PrivateRoute>
                <NotificheTot />
              </PrivateRoute>
            }
          />
          <Route
            path="/amministratore/messaggio/:id"
            element={
              <PrivateRoute>
                <MessaggioAdmin />
              </PrivateRoute>
            }
          />
          <Route
            path="/amministratore/elenco-annunci"
            element={
              <PrivateRoute>
                <ElencoAnnunci />
              </PrivateRoute>
            }
          />
          <Route
            path="/amministratore/annuncio/:id"
            element={
              <PrivateRoute>
                <DettaglioAnnuncio />
              </PrivateRoute>
            }
          />
          {/* FINE SEZIONE SUPERAMMINISTRATORE */}

          <Route path="/annunci-recenti" element={<AnnunciRecenti />} />

          <Route path="/cerca" element={<Cerca />} />

          <Route path="/necrologio/:id/:slug" element={<Necrologio />} />
        </Routes>
      </UserProvider>
    </Router>
  );
}

export default App;
